/* ------------------------------------------------------------ frame */

.room {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding-top: var(--safe-top);
}

.bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--s-1);
  min-height: 56px;
  padding: 0 4px;
  background: rgba(6, 6, 6, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--char);
}
.barMid { min-width: 0; display: grid; line-height: 1.15; }
.barTitle { font-family: var(--f-display); font-weight: 800; font-size: var(--t-xl); text-transform: uppercase; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.barSub { font-family: var(--f-cond); font-weight: 600; font-size: var(--t-sm); color: var(--dust); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.barActions { display: flex; }

.conn { display: flex; justify-content: center; padding: 4px; background: var(--stop-dim); font-family: var(--f-cond); font-weight: 600; font-size: var(--t-sm); }

/* ------------------------------------------------------------ lobby */

.lobby { width: 100%; max-width: var(--content); margin: 0 auto; padding: var(--s-5) var(--gutter) calc(150px + var(--safe-bottom)); display: grid; gap: var(--s-8); }
.lobbyMain { display: grid; gap: var(--s-8); align-content: start; min-width: 0; }
.lobbySide { display: none; }
@media (min-width: 960px) {
  .lobby { max-width: 1120px; grid-template-columns: minmax(0, 1.5fr) minmax(320px, 1fr); column-gap: var(--s-10); align-items: start; padding-bottom: var(--s-12); }
  .lobbySide { position: sticky; top: calc(var(--header-h) + var(--s-5)); display: grid; gap: var(--s-8); }
  .sideActions { display: grid; gap: var(--s-2); }
  .sideChat { height: 340px; }
}

.roomBlock { display: grid; gap: var(--s-4); }

.prizes { display: grid; gap: 1px; background: var(--steel); border: 1px solid var(--steel); }
.prize { display: flex; justify-content: space-between; align-items: center; gap: var(--s-3); min-height: 56px; padding: var(--s-2) var(--s-4); background: var(--char); }
.prize span { display: grid; gap: 2px; color: var(--chalk); font-weight: 500; }
.prize small { color: var(--ash); font-size: var(--t-sm); font-weight: 400; }
.prize b { font-family: var(--f-display); font-weight: 800; font-size: var(--t-2xl); line-height: 1; white-space: nowrap; }
.prizeTotal { background: var(--slab); }
.prizeTotal span { font-family: var(--f-cond); font-weight: 700; color: var(--dust); }
.prizeTotal b { color: var(--sodium); font-size: var(--t-3xl); }

.invite { display: grid; gap: var(--s-3); }
.inviteBtns { display: grid; grid-template-columns: 1fr 1fr; gap: var(--s-2); }
.inviteMore { display: flex; flex-wrap: wrap; gap: 0 var(--s-2); margin-left: calc(var(--s-3) * -1); }

.players { display: grid; }
.player { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: var(--s-3); min-height: 56px; border-bottom: 1px solid var(--steel); }
.player[data-left='true'] { opacity: 0.45; }
.conDot { width: 9px; height: 9px; border-radius: 50%; background: var(--grit); }
.conDot[data-on='true'] { background: var(--go); box-shadow: 0 0 8px var(--go); }
.playerEnd { display: flex; align-items: center; gap: var(--s-2); }

.lineup { display: grid; grid-template-columns: repeat(auto-fill, minmax(60px, 1fr)); gap: 1px; padding: 1px; }
.slot { display: grid; justify-items: center; gap: 6px; padding: var(--s-2) 4px var(--s-3); background: var(--char); box-shadow: 0 0 0 1px var(--steel); }
.slotNo { font-family: var(--f-display); font-weight: 800; font-size: var(--t-lg); line-height: 1; color: var(--ash); }
.slot[data-now='true'] { background: var(--slab-hi); box-shadow: 0 0 0 1px var(--steel), inset 0 -3px 0 var(--sodium); }
.slot[data-now='true'] .slotNo { color: var(--sodium); }
.slot[data-done='true'] { opacity: 0.45; }

.ticker { display: flex; gap: var(--s-2); align-items: center; width: 100%; min-height: 48px; padding: 0 var(--s-3); border: 1px solid var(--steel); background: var(--char); color: var(--dust); text-align: left; font-size: var(--t-sm); }
.ticker svg { flex: none; color: var(--ash); }
.ticker b { color: var(--chalk); font-weight: 600; flex: none; }
.ticker span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.dock {
  position: fixed;
  left: 0; right: 0; bottom: 0;
  z-index: 20;
  padding: var(--s-3) var(--gutter) calc(var(--s-3) + var(--safe-bottom));
  background:
    repeating-linear-gradient(45deg, transparent 0 7px, rgba(255, 255, 255, 0.022) 7px 8px),
    repeating-linear-gradient(-45deg, transparent 0 7px, rgba(255, 255, 255, 0.022) 7px 8px),
    rgba(12, 12, 11, 0.97);
  border-top: 1px solid var(--steel);
  box-shadow: 0 -24px 32px -8px rgba(0, 0, 0, 0.7);
}
.dockInner { width: 100%; max-width: var(--content); margin: 0 auto; display: grid; gap: var(--s-2); }
.dockRow { display: grid; grid-template-columns: 1fr 1fr; gap: var(--s-2); }
.waitRow { display: grid; grid-template-columns: 1fr auto; align-items: center; gap: var(--s-3); min-height: var(--tap); }
.waiting { display: flex; align-items: center; gap: var(--s-2); color: var(--dust); font-family: var(--f-cond); font-weight: 600; line-height: 1.25; }
.waitLamp { flex: none; width: 9px; height: 9px; border-radius: 50%; background: var(--fluoro); box-shadow: 0 0 8px var(--fluoro); animation: pulse 1.6s ease-in-out infinite; }
@keyframes pulse { 50% { opacity: 0.3; } }

/* ------------------------------------------------------------ countdown */

.count {
  flex: 1;
  display: grid;
  grid-template-rows: auto 1fr auto auto;
  text-align: center;
  overflow: hidden;
}
.countBody { display: grid; place-items: center; align-content: center; gap: var(--s-4); padding: var(--s-4) var(--gutter); position: relative; }
/* one work light swinging slowly over the room */
.countBody::before {
  content: '';
  position: absolute;
  inset: -20% -40%;
  background: conic-gradient(from 0deg at 50% 0%, transparent 0 40%, rgba(245, 162, 58, 0.14) 46%, transparent 52% 100%);
  animation: sweep 6s ease-in-out infinite alternate;
  pointer-events: none;
}
@keyframes sweep { from { transform: rotate(-18deg); } to { transform: rotate(18deg); } }
.countLabel { font-family: var(--f-cond); font-weight: 600; color: var(--dust); font-size: var(--t-lg); position: relative; }
.countNum {
  position: relative;
  font-family: var(--f-stencil);
  font-weight: 800;
  font-size: clamp(9rem, 56vw, 18rem);
  line-height: 0.8;
  color: var(--sodium);
  font-variant-numeric: tabular-nums;
}
.countNum[data-hot='true'] { color: var(--chalk); }
.slam { animation: slam 420ms var(--ease-slam) both; }
@keyframes slam { from { transform: scale(1.25); opacity: 0.2; } }
.countNext { position: relative; display: grid; gap: var(--s-2); justify-items: center; }
.countGame { display: inline-flex; align-items: center; gap: var(--s-3); padding: var(--s-2) var(--s-4) var(--s-2) var(--s-3); border: 1px solid var(--steel); border-left: 3px solid var(--accent); background: rgba(21, 21, 19, 0.8); }
.countGame b { font-family: var(--f-display); font-weight: 800; font-size: var(--t-2xl); line-height: 1; text-transform: uppercase; }
.countFoot { padding: var(--s-4) var(--gutter) calc(var(--s-4) + var(--safe-bottom)); display: grid; gap: var(--s-3); width: 100%; max-width: 560px; margin: 0 auto; }

/* ------------------------------------------------------------ stage intro: the game's title card */

.intro {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--s-5);
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: var(--s-5) var(--gutter) calc(var(--s-5) + var(--safe-bottom));
}
/* the game's own light falls on its title card */
.intro::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background: radial-gradient(90% 45% at 15% 0%, color-mix(in srgb, var(--accent) 16%, transparent), transparent 70%);
}
.introStage { display: flex; align-items: flex-end; gap: var(--s-3); }
.introNo { font-family: var(--f-display); font-weight: 900; font-size: clamp(5rem, 30vw, 8rem); line-height: 0.78; color: var(--accent); animation: slam 480ms var(--ease-slam) both; }
.introOf { font-family: var(--f-cond); font-weight: 600; color: var(--dust); padding-bottom: 6px; line-height: 1.2; }
.introMark { margin-left: auto; padding: var(--s-2); border: 1px solid var(--steel); background: var(--char); }
.introTitle { display: grid; gap: var(--s-1); }
.introName { font-family: var(--f-display); font-weight: 900; font-size: clamp(2.6rem, 12vw, 4rem); line-height: 0.88; text-transform: uppercase; }
.introTag { color: var(--dust); font-size: var(--t-lg); }
.introRules { margin: 0; padding: var(--s-4) 0 0; list-style: none; display: grid; gap: var(--s-3); counter-reset: r; border-top: 1px solid var(--steel); }
.introRules li { display: grid; grid-template-columns: 24px 1fr; gap: var(--s-2); counter-increment: r; line-height: 1.38; }
.introRules li::before { content: counter(r); font-family: var(--f-display); font-weight: 800; font-size: var(--t-lg); line-height: 1.1; color: var(--accent); }
.introFacts { display: flex; flex-wrap: wrap; gap: var(--s-2); }
/* short phones: the whole title card, rules and timer still fit on one screen */
@media (max-height: 740px) {
  .intro { gap: var(--s-3); padding-top: var(--s-3); }
  .introNo { font-size: clamp(3.6rem, 20vw, 5rem); }
  .introMark svg { width: 44px; height: 44px; }
  .introName { font-size: clamp(2.1rem, 10vw, 2.8rem); }
  .introTag { font-size: var(--t-md); }
  .introRules { gap: var(--s-2); padding-top: var(--s-3); font-size: var(--t-sm); }
}

/* ------------------------------------------------------------ the floor (gameplay) */

.floor {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding-top: var(--safe-top);
  overflow: hidden;
}
.stageBar {
  display: grid;
  gap: var(--s-2);
  /* on wide screens the timer stays over the board, not across the window */
  padding: var(--s-2) max(var(--gutter), calc((100% - 640px) / 2)) var(--s-3);
  border-bottom: 1px solid var(--char);
  box-shadow: inset 0 2px 0 var(--accent);
  background: linear-gradient(180deg, color-mix(in srgb, var(--accent) 7%, transparent), transparent);
}
.stageLine { display: flex; justify-content: space-between; align-items: center; gap: var(--s-3); font-family: var(--f-cond); font-weight: 600; font-size: var(--t-md); color: var(--dust); }
.stageLine b { color: var(--chalk); }
.standing { display: flex; align-items: center; gap: var(--s-2); }
.standing b { font-family: var(--f-display); font-weight: 800; font-size: var(--t-xl); color: var(--go); }
.revealLabel { font-family: var(--f-display); font-weight: 800; font-size: var(--t-xl); text-transform: uppercase; color: var(--fluoro); letter-spacing: 0.02em; }
.fieldLine { display: flex; align-items: center; justify-content: space-between; gap: var(--s-3); min-height: 18px; font-family: var(--f-cond); font-weight: 600; font-size: var(--t-sm); color: var(--ash); }
.fieldLine > span { flex: none; }
.board {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: var(--s-3) var(--gutter) calc(var(--s-3) + var(--safe-bottom));
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
}
.verdict { display: grid; justify-items: center; gap: var(--s-2); padding: var(--s-2) 0 var(--s-3); text-align: center; }
.verdictWhy { color: var(--dust); font-size: var(--t-sm); max-width: 40ch; }

/* ------------------------------------------------------------ stage result */

.result { flex: 1; display: flex; flex-direction: column; gap: var(--s-6); padding: var(--s-5) var(--gutter) calc(var(--s-5) + var(--safe-bottom)); max-width: 640px; width: 100%; margin: 0 auto; }
.resultWin { display: grid; gap: var(--s-2); justify-items: start; }
.resultStage { display: inline-flex; align-items: center; gap: var(--s-2); padding: 4px var(--s-3) 4px 4px; margin-bottom: var(--s-2); border: 1px solid var(--steel); border-left: 3px solid var(--accent); font-family: var(--f-cond); font-weight: 600; font-size: var(--t-sm); color: var(--dust); }
.resultName { font-family: var(--f-display); font-weight: 900; font-size: clamp(2.8rem, 14vw, 4.4rem); line-height: 0.86; text-transform: uppercase; color: var(--sodium); overflow-wrap: anywhere; animation: slam 480ms var(--ease-slam) both; }
.resultName[data-none] { color: var(--dust); }
.tally { display: grid; gap: var(--s-1); }
.tallyRow { display: grid; grid-template-columns: 28px 1fr auto; gap: var(--s-3); align-items: center; min-height: 46px; border-bottom: 1px solid var(--steel); }
.tallyRow[data-me='true'] .tallyName { color: var(--sodium); }
.tallyNo { font-family: var(--f-display); font-weight: 800; font-size: var(--t-lg); color: var(--ash); text-align: right; }
.tallyName { font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tallyVal { font-family: var(--f-display); font-weight: 800; font-size: var(--t-2xl); line-height: 1; }

/* ------------------------------------------------------------ finished */

.final { width: 100%; max-width: var(--content); margin: 0 auto; padding: var(--s-6) var(--gutter) calc(var(--s-10) + var(--safe-bottom)); display: grid; gap: var(--s-8); }

/* ------------------------------------------------------------ chat */

.chat { display: flex; flex-direction: column; height: 100%; gap: var(--s-3); }
.msgs { flex: 1; min-height: 0; overflow-y: auto; display: flex; flex-direction: column; gap: var(--s-2); }
.msg { display: grid; gap: 2px; }
.msg b { font-family: var(--f-cond); font-weight: 700; font-size: var(--t-sm); color: var(--dust); }
.msg[data-me='true'] b { color: var(--sodium); }
.msg time { color: var(--ash); font-weight: 600; margin-left: 4px; }
.msg p { overflow-wrap: anywhere; }
.sys { font-size: var(--t-sm); color: var(--ash); font-family: var(--f-cond); font-weight: 600; border-left: 2px solid var(--steel); padding-left: var(--s-2); }
.compose { display: grid; grid-template-columns: 1fr auto; gap: var(--s-2); }

/* ------------------------------------------------------------ gate (public tournament you haven't joined) */

.gate { padding: calc(var(--safe-top) + var(--s-8)) var(--gutter) var(--s-10); max-width: 560px; margin: 0 auto; display: grid; gap: var(--s-4); }

/* ------------------------------------------------------------ rules sheet */

.sheetGame { font-family: var(--f-display); font-weight: 900; font-size: var(--t-3xl); line-height: 0.9; text-transform: uppercase; }
.sheetRules { margin: 0; padding: 0; list-style: none; display: grid; gap: var(--s-3); counter-reset: r; }
.sheetRules li { display: grid; grid-template-columns: 22px 1fr; gap: var(--s-2); counter-increment: r; line-height: 1.38; }
.sheetRules li::before { content: counter(r); font-family: var(--f-display); font-weight: 800; color: var(--sodium); }
